module.exports = __webpack_public_path__ + "img/online.2e165f26.png";